import { render, staticRenderFns } from "./SpendUsageBarChart.vue?vue&type=template&id=66c40b00&"
import script from "./SpendUsageBarChart.vue?vue&type=script&lang=ts&"
export * from "./SpendUsageBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports